import { createApiClient, env } from '@botto/core';
import type { paths } from './generated/schema';

/**
 * Billing / MulticurrencyAPI client (module «Тарифы»).
 *
 * Access JWT is obtained for audience `tariffs` (`VITE_TARIFFS_AUTH_APP_NAME`,
 * default `billing-api`) via POST /auth/token and sent as
 * `Authorization: Bearer <jwt>`. Base URL: `/api/billing`.
 */
export const tariffsApi = createApiClient<paths>({
  baseUrl: env.tariffsApiUrl,
  audience: 'tariffs',
});
